import React, { useState, useEffect } from "react";
import {
  Stack,
  Paper,
  Typography,
  IconButton,
  Collapse,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { context_styles } from "../context_builder_dark_styles";
import { Projects } from "../context_components/projects";
import {
  analysisActions,
  contextBuilderActions,
  feedbackActions,
  sosAndSodActions,
} from "../../store/store";
import { useDispatch, useSelector } from "react-redux";
import { useSpring, animated } from "@react-spring/web";
import axios from "axios";

export default function SosAndSodAnalyze() {
  const dispatch = useDispatch();

  // const [selectedAudit, setSelectedAudit] = useState(null);
  const [loadedData, setLoadedData] = useState({});
  const {
    currentSearchMode,
    searchModes,
    storeData,
    sessionAuditList,
    selectedAudit,
    userList,
    storeList,
    audits,
    selectedOption,
    selectedType,
  } = useSelector((state) => state.defaultTabStore);
  const { projectInfo, projects } = useSelector(
    (state) => state.projectInfoStore
  );
  const { sodResponse } = useSelector((state) => state.sosSodStore);
  const searchEntity = useSelector(
    (state) => state.defaultTabStore.search_input
  );
  const load = useSelector((state) => state.contextBuilderStore.load);
  const { loading } = useSelector((state) => state.feedbackStore);
  const { color, col_100 } = useSelector((state) => state.themeStore);
  const baseProject = projectInfo[2];
  const config = projects.filter(
    (r) => r.country === projectInfo[0] && r.env === projectInfo[1]
  )[0];

  const [springs, api] = useSpring(() => ({
    from: {
      y: 0,
    },
    config: {
      mass: 7,
    },
  }));

  useEffect(() => {
    api.start({
      from: {
        y: -15 + "%",
      },
      to: {
        y: 0 + "%",
      },
    });
  }, []);

  useEffect(() => {
    console.log("Selected Audit Updated:", selectedAudit);
    console.log("Loaded Data", loadedData);
    // console.log(loadedData["00778L4TGZI1Z9V"].relatedTagsLength)
  }, [selectedAudit, loadedData]);
  const handlePageChange = () => {
    dispatch(contextBuilderActions.changePage("default"));
  };

  const list_styles = {
    display: "flex",
    justifyContent: "center",
    // overflowY: "scroll",
    maxHeight: "52vh",
    minHeight: "fit-content",
    width: "16.5rem",
  };
  const list_styles_for_tags = {
    display: "flex",
    flexDirection: "column",
    gap: "0.5rem",

    overflowY: "scroll",
    maxHeight: "45vh",
    // minHeight: "fit-content",
    // width: "16.5rem",
  };

  return (
    <animated.div style={{ ...springs }}>
      <Paper elevation={5} sx={context_styles}>
        <Stack className="brand-analysis" spacing={0} sx={{ p: 1 }}>
          <Stack direction="row" className="page-header-dark">
            <ChevronLeftIcon className="left-dark" onClick={handlePageChange} />
            <span style={{ fontSize: "0.9rem" }}>SOS & SOD Analysis</span>
            <div className="right-dark"></div>
          </Stack>
          <div style={list_styles} className="context-scroll-dark">
            <Stack
              direction="column"
              spacing={2}
              style={{ height: "50vh", width: "86%", marginTop: "0.4rem" }}
            >
              <div
                style={{
                  marginTop: "0.5rem",
                  textAlign: "center",
                  padding: "0.5rem 1rem",
                  fontSize: "0.8rem",
                  color: "rgba(255, 255, 255, 0.5)",
                  border: "2px solid rgba(32, 38, 43, 0.95)",
                  borderBottom: "2px solid grey",
                  // backgroundColor: "rgba(32, 38, 43, 0.95)",
                  borderRadius: "4px",
                }}
              >
                {selectedAudit}
              </div>
              <div style={list_styles_for_tags} className="context-scroll-dark">
                {sodResponse.map((item, index) => (
                  <Accordion
                    key={index}
                    disableGutters
                    style={{
                      color: "rgba(255, 255, 255, 0.5)",
                      backgroundColor: "rgba(32, 38, 43, 0.95)",
                      borderRadius: "12px",
                    }}
                  >
                    <AccordionSummary
                      sx={{ minHeight: "40px" }}
                      expandIcon={
                        <ExpandMoreIcon
                          style={{ color: "rgba(255, 255, 255, 0.5)" }}
                        />
                      }
                      aria-controls={`panel-${index}-content`}
                      id={`panel-${index}-header`}
                    >
                      {/* <Typography>{`Question ID: ${item.data[0].question_id}`}</Typography> */}
                      <span style={{ fontSize: "0.8rem" }}>
                        {item.data[0].question_id}
                      </span>
                    </AccordionSummary>
                    <AccordionDetails
                      style={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        justifyContent: "flex-start",
                        gap: "0.5rem",
                        borderTop: "1px solid #3b3b3b",
                        padding: "0.5rem 0.7rem",
                      }}
                    >
                      {item.data.map((tag, tagIndex) => (
                        <>
                          <span
                            style={{
                              width: "100%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              fontSize: "0.7rem",
                            }}
                          >
                            <span> {tag.tag_id}</span>

                            <div
                              style={{
                                padding: "0.3rem 0.8rem",
                                backgroundColor: "#3b3b3b",
                                borderRadius: "4px",
                                width: "34%",
                                textAlign: "center",
                              }}
                            >
                              {tag.count}
                            </div>
                          </span>
                        </>
                      ))}
                      <span
                        style={{
                          width: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          fontSize: "0.7rem",
                        }}
                      >
                        <span> {item.data[0].type}</span>

                        <div
                          style={{
                            padding: "0.3rem 0.8rem",
                            backgroundColor: "#3b3b3b",
                            borderRadius: "12px",
                            width: "34%",
                            textAlign: "center",
                          }}
                        >
                          {item.percentage}%
                        </div>
                      </span>
                    </AccordionDetails>
                  </Accordion>
                ))}
              </div>
            </Stack>
          </div>
        </Stack>
        <Projects />
      </Paper>
    </animated.div>
  );
}
